export function getPercent(value: number, max: number) {
  return (value / max) * 100
}
